<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="700px"
    transition="dialog-transition"
  >
    <template #activator="{attrs}">
      <v-btn
        :loading="loading"
        class="teal white--text"
        v-bind="attrs"
        @click="OpenNewItem"
      >
        <slot>
          <v-icon>fas fa-plus</v-icon>
        </slot>
      </v-btn>
    </template>
    <v-card class="grey darken-3">
      <v-card-title class="white--text">
        ADD NEW ITEM
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-form v-model="valid" ref="NewItemForm">
          <v-select
            dark
            outlined
            chips
            deletable-chips
            :rules="[rules.required]"
            :items="categList"
            item-value="_id"
            item-text="AccountName"
            v-model.trim="categID"
            label="Inventory"
          ></v-select>
          <v-select
            dark
            outlined
            chips
            deletable-chips
            multiple
            :rules="[rules.items]"
            :loading="loaditem"
            :items="items"
            item-value="_id"
            item-text="ItemName"
            return-object
            v-model.trim="ItemName"
            label="Inventory"
          ></v-select>
        </v-form>
        <newInventory
          v-for="item in ItemName"
          :key="item.ItemID"
          :ItemRow="item"
        ></newInventory>
        <!-- <p>{{ ItemName }}</p> -->
        <!-- <p>{{ categList }}</p> -->
        <v-row v-if="ErrMsg" class="grey lighten-3 justify-center">
          <p v-html="ErrMsg" class="error--text body my-auto"></p>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :loading="isloading"
          @click="OnSaveNewItem"
          :disabled="!valid"
          rounded
          block
          :color="btnColor"
          dark
          >Save Items
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    newInventory: () => import("./_ExpectedQty"),
  },
  props: {
    OrderCode: { type: String, required: true },
    OnFinish: { type: Function, required: true },
  },
  data() {
    return {
      Stock: "/stock/Ontheway",
      URL: "/AccCharts",
      ErrMsg: "",
      valid: false,
      isloading: false,
      dialog: false,
      loading: false,
      loaditem: false,
      items: [],
      categList: [],
      ItemName: [],
      categID: "",

      rules: {
        required: value => !!value || "Required.",
        items: value => !!value.length || "Required.",
        // ItemName
      },
    };
  },
  watch: {
    categID(val) {
      //   console.log(val);
      this.items = [];
      this.ItemName = [];
      if (val) {
        try {
          this.loaditem = true;

          let ReqInv = {
            url: `${this.URL}/notinorder`,
            query: { CategName: val, OrderCode: this.OrderCode },
          };
          this.getReByQuery(ReqInv)
            .then(({ data }) => {
              // console.log(data);
              this.loaditem = false;
              //   this.Payed = cost;
              //   this.SelectedSupp = cost.Description;
              this.items = data;
            })
            .catch(() => {
              this.loaditem = false;
            });
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    btnColor() {
      return this.UsersToken.UserBranch == "company"
        ? "teal darken-2"
        : "error";
    },
  },
  methods: {
    OnSaveNewItem() {
      // this.$refs.NewItemForm.resetValidation()
      //   console.log(this.valid);
      this.ErrMsg = "";
      this.isloading = true;
      this.$store
        .dispatch("INSERT_ONLY", {
          url: this.Stock + "/newItem",
          data: this.ItemName,
        })
        .then(result => {
          this.OnFinish(result.data, true);
          this.close();
          // this.isloading = false;
        })
        .catch(err => {
          console.log(err);
          this.ErrMsg = err && err.response && err.response.data;
        })
        .finally(() => {
          this.isloading = false;
          // console.log("Final");
        });
    },
    getReByQuery(value) {
      return this.$store.dispatch("FIND_BY_VALUE", value);
    },
    OpenNewItem() {
      this.loading = true;
      const CategReq = {
        url: `${this.URL}/Category`,
        query: {},
      };
      this.getReByQuery(CategReq)
        .then(val => {
          this.loading = false;
          this.dialog = true;
          //   console.log(val);
          this.categList = val.data;
        })
        .catch(err => {
          this.loading = false;
          this.dialog = false;
          console.log(err);
        });
    },
    close() {
      this.dialog = false;
      this.categList = [];
      this.categID = "";
      this.$refs.NewItemForm.resetValidation();
    },
  },
};
</script>
